import { EventEmitter } from '@angular/core';
import { BulkUploadInfluencer, InfluencerGroup, BulkUploadInfluencerDetail } from '../../../../../models/influencer-group';
import { TranslateService } from '@ngx-translate/core';
import { listOrderedPlatforms } from '../../../../app.constants';
var BulkUploadInfluencerModalComponent = /** @class */ (function () {
    function BulkUploadInfluencerModalComponent(translate) {
        this.translate = translate;
        this.bulkUploadInfluencer = new BulkUploadInfluencer();
        this.beforeUploadBulkInfluencerEvent = new EventEmitter();
    }
    BulkUploadInfluencerModalComponent.prototype.uploadBulkInfluencer = function () {
        this.beforeUploadBulkInfluencerEvent.emit({
            data: this.bulkUploadInfluencer
        });
    };
    BulkUploadInfluencerModalComponent.prototype.checkInvalidInput = function (inputValue) {
        var _this = this;
        var invalidInputArr = [];
        inputValue.forEach(function (item) {
            var influencerItem = item.replace(/\s+/g, '').split(',');
            if (_this.hasInvalidFormatOrPlatform(influencerItem)) {
                invalidInputArr.push(influencerItem);
            }
        });
        return invalidInputArr;
    };
    BulkUploadInfluencerModalComponent.prototype.hasInvalidFormatOrPlatform = function (influencerItem) {
        return influencerItem.length !== BulkUploadInfluencerModalComponent.NUMBER_INFLUENCER_INFO_ITEM || !influencerItem[0] || (influencerItem[0] && listOrderedPlatforms.filter(function (platformItem) { return platformItem.name.toLowerCase() === influencerItem[1].toLowerCase(); }).length === 0);
    };
    BulkUploadInfluencerModalComponent.prototype.mappingInputValue = function (bulkInfluencerData) {
        return bulkInfluencerData.map(function (item) {
            var splitedItem = item.replace(/\s+/g, '').split(',');
            var data = new BulkUploadInfluencerDetail();
            data.handle = splitedItem[0];
            data.platform = splitedItem[1];
            return data;
        });
    };
    Object.defineProperty(BulkUploadInfluencerModalComponent.prototype, "disableContinueButton", {
        get: function () {
            return !this.bulkUploadInfluencerInputValue || (this.bulkUploadInfluencerInputValue && this.validationErrorMsg);
        },
        enumerable: true,
        configurable: true
    });
    BulkUploadInfluencerModalComponent.prototype.focusoutEvent = function () {
        var bulkValue = this.bulkUploadInfluencerInputValue.split('\n');
        if (this.bulkUploadInfluencerInputValue && bulkValue.length > BulkUploadInfluencerModalComponent.MAX_INFLUENCER_NUMBER) {
            this.validationErrorMsg = this.translate.instant('bulk_upload_influencer.modal.exceed_max_influencer_number');
        }
        else if (this.bulkUploadInfluencerInputValue && this.checkInvalidInput(bulkValue).length > 0) {
            this.validationErrorMsg = this.translate.instant('bulk_upload_influencer.modal.invalid_input');
        }
        else {
            this.validationErrorMsg = null;
            this.bulkUploadInfluencer.influencers = this.mappingInputValue(bulkValue);
        }
    };
    BulkUploadInfluencerModalComponent.prototype.inputEvent = function () {
        this.validationErrorMsg = null;
    };
    BulkUploadInfluencerModalComponent.MAX_INFLUENCER_NUMBER = 100;
    BulkUploadInfluencerModalComponent.NUMBER_INFLUENCER_INFO_ITEM = 2;
    return BulkUploadInfluencerModalComponent;
}());
export { BulkUploadInfluencerModalComponent };



// WEBPACK FOOTER //
// ./src/app/main/bottombar-influencer-fragement/bulk-upload-influencer/bulk-upload-influencer-modal/bulk-upload-influencer-modal.component.ts.pre-build-optimizer.js